import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MasterService } from '../../services/master.service';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonContact, Contact } from '../../models/contact';
import { CommonService } from '../../services/common.service';


@Component({
  selector: 'app-email-multi',
  templateUrl: './email-multi.component.html',
  styleUrls: ['./email-multi.component.css']
})
export class EmailMultiComponent implements OnInit, OnChanges {
  emailtypeList = [];
  @Input() contactForm: FormGroup;
  emailFormArray: FormArray;
  @Input() contactFilter: string[];
  @Input() formArrayName: string;
  @Input() commonContact: CommonContact[] = [];
  tempData = [];
  rowCount = 1;
  emailIds = [];
  filterOptionsList = [];
  seletected = [];
  objemail = {
    contactId: 0,
    transContactId: 0,
    contactData: '',
  };
  contact: Contact = new Contact();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private common: CommonService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.commonContact.firstChange) {
      this.createControls();
    }
  }

  ngOnInit() {
    this.getContactLookup();
    this.addItem();
  }
  createControls() {
    if (this.commonContact.length > 0) {
      this.emailFormArray = this.contactForm.get(this.formArrayName) as FormArray;
      this.emailFormArray.removeAt(0);
      for (let i = 0; this.commonContact.length > i; i++) {
        this.addItem();
        for (let j = 0; this.commonContact[i].contact.length > j; j++) {
          this.createemailcontrol(i);
        }
      }
      this.emailIds = this.commonContact;
      setTimeout(() => {
        this.contactForm.get(this.formArrayName).patchValue(this.emailIds);
      }, 0);
    }
  }
  getContactLookup() {
    this.masterService.GetContactLookup().subscribe(res => {
      if (res) {
        this.tempData = res;
        this.emailtypeList = this.tempData.filter(f => this.contactFilter.some(s => s === f.lookUpName));
      }
    });
  }
  initemailfrm(): FormGroup {
    return this.formBuilder.group({
      contact: new FormArray([]),
      lookupId: new FormControl(''),
      emailaddress: new FormControl('', Validators.compose(
        [Validators.pattern(this.common.EmailRegX), Validators.minLength(1)])),
    });
  }
  initcontact(): FormGroup {
    return this.formBuilder.group({
      contactId: new FormControl(0),
      transContactId: new FormControl(0),
      contactData: new FormControl(),
    });
  }
  addItem(): void {
    const objEmail = {
      lookupId: 0,
      contact: [],
    };
    this.emailFormArray = this.contactForm.get(this.formArrayName) as FormArray;
    if (this.contactFilter.length > this.emailFormArray.length) {
      this.emailIds.push(this.common.CloneObject(objEmail));
      this.emailFormArray.push(this.initemailfrm());
      this.rowCount = this.emailFormArray.length;
    }
    // this.filterOptions = this.emailtypeList
  }
  removecontrol(data: any) {
    const frmlength = this.emailFormArray.length;
    if (frmlength > 1) {
      // control refers to your formarray
      const control = this.contactForm.get(this.formArrayName) as FormArray;
      // remove the chosen row
      control.removeAt(data);
      this.emailIds.splice(data, 1);
      this.rowCount = control.length;
    }
  }
  add(event: MatChipInputEvent, index): void {
    const obj1 = {
      lookupId: 0,
      contact: [],
    };
    this.emailFormArray = this.contactForm.get(this.formArrayName) as FormArray;
    const frmgroup = this.emailFormArray.controls[index] as FormGroup;
    const control = frmgroup.get('emailaddress');
    if (control.valid) {
      const input = event.input;
      const value = event.value;

      if (this.emailIds[index].contact.some(s => s.contactData === control.value)) {
        control.setValidators(Validators.compose(
          [Validators.pattern(this.common.EmailRegX),
          Validators.minLength(1)]));
        control.setErrors({ alreadyExist: true });
      } else {
        // Add our email
        if ((value || '').trim()) {
          const objEmail = this.common.CloneObject(this.objemail);
          objEmail.contactData = value;
          const ggt = frmgroup.get('contact') as FormArray;
          ggt.push(this.initcontact());
          this.emailIds[index].contact.push(objEmail);
        }
        if (input) {
          input.value = '';
          control.setValue('');
        }
      }
      frmgroup.get('contact').setValue(this.emailIds[index].contact);
    } else {
      control.setValidators(Validators.compose(
        [Validators.pattern(this.common.EmailRegX),
        Validators.minLength(1)]));
      control.updateValueAndValidity();
      control.setErrors({ incorrect: true });
      control.markAsTouched();
    }
  }
  createemailcontrol(index) {
    this.emailFormArray = this.contactForm.get(this.formArrayName) as FormArray;
    const frmgroup = this.emailFormArray.controls[index] as FormGroup;
    const contactfrm = frmgroup.get('contact') as FormArray;
    contactfrm.push(this.initcontact());
  }
  remove(fruit, i): void {
    this.emailFormArray = this.contactForm.get(this.formArrayName) as FormArray;
    const frmgroup = this.emailFormArray.controls[i] as FormGroup;
    const ggt = frmgroup.get('contact') as FormArray;
    // ggt.push(this.initcontact());
    const contactindex = this.emailIds[i].contact.findIndex(f => f.contactData === fruit.contactData &&
      f.contactId === fruit.contactId && f.transContactId === fruit.transContactId);
    // const index = this.emailIds[i].contact.indexOf(fruit);
    if (contactindex >= 0) {
      ggt.removeAt(contactindex);
      this.emailIds[i].contact.splice(contactindex, 1);
    }
  }
  getContactFormGroup() {
    return (this.contactForm.get(this.formArrayName) as FormArray).controls;
  }
}
